import { ALO_API_HOST } from 'src/scripts/utils/constants';
import { getAloApiStageHeader } from 'src/scripts/utils/apigateway-stage';

const getAloApiAuthHeaders = () => {
  const wishlistShopifySettings = window.getWishlistSettings ? window.getWishlistSettings() : null;
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Shopify-Customer-ID': wishlistShopifySettings?.customerId.toString() || '',
    'X-Shopify-Timestamp': wishlistShopifySettings?.timestamp || '',
    'X-Shopify-Signature': wishlistShopifySettings?.signature || '',
    'X-Cookie-Domain': window.location.hostname.replace('www.', ''),
    'Cache-Control': 'max-age=0, no-cache, no-store, must-revalidate',
  };
};

// TODO: add generics when we handle response data here response.json() or axios
export const aloApiFetch = async (path: string, options: RequestInit = {}): Promise<Response> => {
  const headers = {
    ...getAloApiStageHeader(),
    ...(options.headers || {}),
  };

  const response = await fetch(`${ALO_API_HOST}${path}`, {
    ...options,
    headers,
  });

  return response;
};

export const aloApiAuthFetch = async (path: string, options: RequestInit = {}) =>
  aloApiFetch(path, {
    ...options,
    headers: {
      ...options.headers,
      ...getAloApiAuthHeaders(),
    },
  });
